<template>
  <a-modal
    :title="title"
    :width="1300"
    :visible="visible"
    :confirmLoading="false"
    @ok="handleOk"
    @cancel="handleCancel"
    :okButtonProps="{ props: {disabled: disabled} }"
    cancelText="关闭">

    <!-- 统一AC查看-->
    <div v-show="signType=='1'">
      <iframe ref='signIframe' frameBorder="no" :src="iframeUrl" width='100%' height="900" style='border-bottom:1px solid #3D3D3D;'></iframe>
    </div>

    <!-- 工改签章查看-->
    <WorkChangeStamp
      v-show="signType=='2'"
      :isView="1"
      ref="workChangeStamp"
    ></WorkChangeStamp>

  </a-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import WorkChangeStamp from '@/components/WorkChangeStamp'

  export default {
    components: { WorkChangeStamp},
    name: "SignFileShowModal",
    data () {
      return {
        signType:"1",
        title:"签章文件详情",
        visible: false,
        disabled:false,
        iframeUrl: "",
        signedPdfUrl: "",
        sectionId: "",
        type: "",
      }
    },
    created () {
    },
    methods: {
      show (sectionId,type) {
        this.visible = true;
        this.sectionId = sectionId;
        this.type = type;
        let that = this;
        getAction('/ebid-ce/unauthorized/getSignedPdfUrl', {
          sectionId: that.sectionId,
          type: that.type,
        }).then((res) => {
          if (res.success) {
            that.signedPdfUrl=res.result;
          } else {
            that.$message.error("文件不存在");
          }

          if(that.signedPdfUrl){
            if(that.signedPdfUrl.indexOf(".pdf") > 0 || that.signedPdfUrl.indexOf(".PDF") > 0){
              that.signType="1";
              // that.iframeUrl = `${window._CONFIG['frameDomainURL']}` + "/pdfjs/web/viewer.html?file=" + encodeURIComponent(that.signedPdfUrl);
              that.iframeUrl = that.signedPdfUrl;

            }else if(that.signedPdfUrl.indexOf(".ofd") > 0 || that.signedPdfUrl.indexOf(".OFD") > 0){
              that.signType="2";
              that.$refs.workChangeStamp.showOFD(res.result,"","fileUrl")
            }
          }else{
            that.$message.error("文件不存在");
          }
        });

        //this.getRoomInfo(record);
      },
      // getRoomInfo(record){
      //   this.model = Object.assign({}, record);
      //   this.id = record.id;
      //   getAction(this.url.queryById,{id:this.id}).then((res)=>{
      //     if(res.success){
      //       //TODO
      //     }
      //   });
      // },
      close () {
        this.visible = false;
      },
      handleOk () {
        this.visible = false;
      },
      handleCancel () {
        this.visible = false;
      }
    }
  }
</script>

<style scoped>

</style>
